import http from '@/utils/http'

export function getEventStatuses(){
    return http(`/event_statuses`)
}
export function addEventStatuses(data){
    return http.post(`/event_statuses`,data)
}
export function getEventStatusesDetail(id){
    return http(`/event_statuses/${id}`)
}
export function editEventStatuses(id,data){
    return http.put(`/event_statuses/${id}`,data)
}
